export default function useIcons() {
    function handleGetURI(icon: string | null | undefined): string {
        const storageUri = process.env.REACT_APP_STORAGE_URI;
        const storageIconsUri = `${storageUri}/asset_icons/`

        if (icon) {
            return storageIconsUri + icon;
          } else {
            return storageIconsUri + "generic_icon.png";
          }
    }

    return {
        getURI: handleGetURI
    }
}